// INVOICE_STATUS aka PaymentStatus
export enum INVOICE_STATUS {
  PENDING = 'PENDING',
  PAID = 'PAID',
  PRE_PAID_DISMISSAL = 'PRE_PAID_DISMISSAL',
  PRE_PAID_USER = 'PRE_PAID_USER',
  CANCELED = 'CANCELED',
  DIFFER = 'DIFFER',
  ERROR = 'ERROR',
  RESTRUCTURED = 'RESTRUCTURED',
  BANKING_CHARGE_GENERATED = 'BANKING_CHARGE_GENERATED',
}

export const INVOICE_PAYABLE_STATUSES = [INVOICE_STATUS.PENDING];
